import { useRef } from 'preact/hooks';

/**
 * The previously returned array while a new one has the same elements (`===`
 * each), so a refetch of identical data keeps its identity and does not re-run
 * the memos and effects that depend on it (#1091).
 */
export function useStableArray<A extends readonly unknown[] | undefined>(arr: A): A {
    const ref = useRef(arr);
    const prev = ref.current;
    const same = prev !== undefined && arr !== undefined
        && prev.length === arr.length && prev.every((v, i) => v === arr[i]);
    if (!same) {
        ref.current = arr;
    }
    return ref.current;
}
